import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'

const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/common/common",
    dartBaseUrl: API_BASE_URL + "/common/dart"
};

const commonAPIDFN = {
    commonAPI: (APIName, conditions, paths) => {
        return commonAPI[APIName](conditions, paths);
    }
};

const commonAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    selectCommCdByGrpId: (conditions, paths) => {
        const uri = paths || "/selectCommCdByGrpId";
        return axios.get(`${config.baseUrl}${uri}${makeQueryString(conditions)}`);
    },
    selectMetaTag: (conditions, paths) => {
        const uri = paths || "/selectMetaTag"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getMetaTag: (conditions, paths) => {
        const uri = paths || "/getMetaTag"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectPopup: (conditions, paths) => {
        const uri = paths || "/selectPopup"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getPopup: (conditions, paths) => {
        const uri = paths || "/getPopup"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectHomepageNotice: (conditions, paths) => {
        const uri = paths || "/selectHomepageNotice";
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getHomepageNotice: (conditions, paths) => {
        const uri = paths || "/getHomepageNotice";
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    updateHomepageNoticeQryCnt: (conditions, paths) => {
        const uri = paths || "/updateHomepageNoticeQryCnt";
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectTerms: (conditions, paths) => {
        const uri = paths || "/selectTerms"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getTerms: (conditions, paths) => {
        const uri = paths || "/getTerms"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getBusinessInfo: (conditions, paths) => {
        const uri = paths || "/getBusinessInfo";
        return axios.get(
            `${config.dartBaseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
};

export { commonAPIDFN, commonAPI };
